import classNames from 'classnames/bind';
import React, { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import MapContainer from '../components/containers/MapContainer/MapContainer';
import styles from './routes.scss';

const cx = classNames.bind(styles);

const Map = () => {
  const [mapLoaded, setMapLoaded] = useState(false);
  const { pathname } = useLocation();
  const hideMap = matchPath(pathname, {
    path: ['/authentication/evoct'],
    exact: false,
  });

  // We want to prevent the map from loading when the URL is the authentication url which is sent out in an email.
  // However, if the map is loaded, we don't want to ever hide the map as it causes problems.
  useEffect(() => {
    if (!hideMap) {
      setMapLoaded(true);
    }
  }, [hideMap]);

  if (!mapLoaded && hideMap) {
    return null;
  }
  return (
    <div
      key="Map-Holder"
      id="mapHolder"
      className={cx('routes__map-holder')}
      style={{
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <MapContainer />
    </div>
  );
};

export default Map;
